import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import Delo from "../../img/organizers/delo.svg";
import Mmr from "../../img/organizers/mmr.svg";
import Top from "../../img/organizers/top100.svg";
import Womo from "../../img/organizers/womo.svg";
import Ekonomika from "../../img/organizers/Logo_Ekonomika.svg";

import Get from "../../img/organizers/get.svg";
import Hrws from "../../img/organizers/hrws.svg";
import Prmrfn from "../../img/organizers/prmrfn.svg";
import She from "../../img/organizers/she.svg";
import Bws from "../../img/organizers/bws.svg";
import Mrktng from "../../img/organizers/mrktng.svg";


const EventOrganizers = () => {
    return (
        <section className="py-[60px] bg-[#f1f3f2] lg:pb-[120px] lg:pt-[180px] overflow-hidden">

            <div className="container max-w-screen-xl mx-auto relative z-30 px-[15px]">

                <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                    <h2 className="text-3xl text-black text-center font-bold uppercase mb-20
                        lg:text-[42px] lg:mb-24 xl:text-[52px]">Організатори</h2>
                </ScrollAnimation>


                <div className="relative mx-auto w-[clamp(340px,70vw,680px)] aspect-square rounded-full
                    flex  items-center justify-center mb-20
                    bg-[linear-gradient(318deg,#009064_0%,#46a37e_50.41%,#ece66a_100%)]">

                    <div className="bg-[radial-gradient(70.21%_70.21%_at_50%_50%,_rgb(247,247,247)_54%,_rgb(244,244,244)_68%,_rgb(235,235,235)_77%,_rgb(220,220,220)_84%,_rgb(199,199,199)_91%,_rgb(172,172,172)_97%,_rgb(158,158,158)_100%)] w-[115%] aspect-square rounded-full absolute -z-[1]"></div>
                    <div className="bg-[radial-gradient(70.21%_70.21%_at_50%_50%,_rgb(247,247,247)_54%,_rgb(244,244,244)_68%,_rgb(235,235,235)_77%,_rgb(220,220,220)_84%,_rgb(199,199,199)_91%,_rgb(172,172,172)_97%,_rgb(158,158,158)_100%)] w-[145%] aspect-square rounded-full absolute -z-[2]"></div>
                    <div className="bg-[radial-gradient(70.21%_70.21%_at_50%_50%,_rgb(247,247,247)_54%,_rgb(244,244,244)_68%,_rgb(235,235,235)_77%,_rgb(220,220,220)_84%,_rgb(199,199,199)_91%,_rgb(172,172,172)_97%,_rgb(158,158,158)_100%)] w-[165%] aspect-square rounded-full absolute -z-[3]"></div>

                    {/* Разделительные линии */}
                    <div className="absolute inset-0">
                        <div className="absolute left-1/2 top-0 h-full w-[5px] bg-white -translate-x-1/2 rotate-45" />
                        <div className="absolute top-1/2 left-0 w-full h-[5px] bg-white -translate-y-1/2 rotate-45" />
                    </div>

                    {/* Центральний круг */}
                    <a href="https://ekonomika.ua/" className="w-[52%] lg:w-[48%] aspect-square bg-white rounded-full shadow-2xl
                        flex flex-col items-center justify-center text-center p-6 z-10">

                        <img src={Ekonomika} alt="Ekonomika" className="mb-2 md:mb-4 w-full max-w-[220px]"/>
                        <p className="text-[10px] lg:text-xl max-w-[200px]">бізнес/медіа бюро, до якого входять:</p>
                    </a>
                    {/* Верхний блок */}
                    
                    <a href="https://delo.ua/" className="absolute -top-[35px] flex flex-col items-center gap-1 lg:gap-3">
                        <div className="w-[clamp(70px,12vw,130px)] aspect-square flex items-center justify-center bg-white p-4 rounded-full 
                            shadow-[0_2px_6px_rgba(0,0,0,0.25)]">
                            <img src={Delo} alt="Delo.ua" className=""/>
                        </div>
                        <p className="text-[10px] font-bold text-white max-w-[95px] text-center md:text-[14px]  md:max-w-[150px] lg:text-[20px] 
                            lg:max-w-[200px]">Лідер ділового контенту Delo.ua</p>
                    </a>

                    {/* Нижний блок */}
                    <a href="https://womo.ua/" className="absolute -bottom-[35px] flex flex-col items-center gap-1 lg:gap-3">
                        <p className="text-[10px] font-bold text-white max-w-[95px] text-center lg:text-[20px] md:text-[14px] md:max-w-[150px]
                            lg:max-w-[200px]">Дайджест ділової жінки Womo.ua</p>

                        <div className="w-[clamp(70px,12vw,130px)] aspect-square flex items-center justify-center bg-white p-4 rounded-full 
                            shadow-[0_2px_6px_rgba(0,0,0,0.25)]">
                            <img src={Womo} alt="Delo.ua" className=""/>
                        </div>
                    </a>


                    {/* Левый блок */}
                    <a href="https://delo.ua/ru/top100/" className="absolute -left-[25px] flex flex-col items-center gap-1">
                        <div className="w-[clamp(70px,12vw,130px)] aspect-square flex items-center justify-center bg-white p-4 rounded-full 
                            md:-ml-12
                            shadow-[0_2px_6px_rgba(0,0,0,0.25)]">
                            <img src={Top} alt="Delo.ua" className=""/>
                        </div>
                        <p className="text-[10px] font-bold text-white max-w-[95px] md:text-[14px] md:max-w-[150px] text-right pl-10 lg:text-[20px]
                            lg:max-w-[188px]">Журнал «ТОП-100. Рейтинги найбільших»</p>
                    </a>

                    {/* Правый блок */}
                    <a href="https://mmr.ua/" className="absolute -right-[25px] flex flex-col items-center gap-1 ">
                        <div className="w-[clamp(70px,12vw,130px)] aspect-square flex items-center justify-center bg-white p-4 rounded-full 
                            md:-mr-12
                            shadow-[0_2px_6px_rgba(0,0,0,0.25)]">
                            <img src={Mmr} alt="Delo.ua" className=""/>
                        </div>
                        <p className="text-[10px] font-bold text-white max-w-[95px] md:text-[14px] md:max-w-[150px] text-left pr-6 lg:text-[20px]
                            lg:max-w-[185px]">Онлайн-медіа про PR і маркетинг MMR.ua</p>
                    </a>
                    
                </div>


                <ScrollAnimation animateIn="animate__fadeInUp" animateOnce={true}>
                    <h2 className="relative text-xl text-center font-bold uppercase mb-6 z-10
                        lg:text-2xl lg:mb-11">Компанія щорічно проводить майже 20 бізнес-заходів, серед яких:
                    </h2>

                    <div className="relative flex flex-col gap-3 md:flex-row md:justify-center md:flex-wrap md:gap-y-4 md:gap-x-6 z-10">
                        <a href="https://get.delo.ua/" className="relative flex items-center gap-6 pr-14 md:basis-[calc(50%-12px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                                shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                                <img src={Get} alt="Delo.ua" className="w-2/3"/>
                            </div>
                            <p className="text-base font-semibold text-white lg:text-lg">ГРАЙ ЯК ВЕЛИКИЙ. Навіть якщо малий</p>
                            
                            <div className="absolute right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                                bg-[linear-gradient(290deg,#009064_0%,#46a37e_25.41%,#e6e47c_100%)]"></div>
                        </a>
                        <a href="https://hrws.delo.ua/" className="relative flex items-center gap-6 pr-14 md:basis-[calc(50%-12px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                                shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                                <img src={Hrws} alt="Delo.ua" className="w-2/3"/>
                            </div>
                            <p className="text-base font-semibold text-white lg:text-lg">HR Wisdom Summit: Люди. Середовище. Місця сили</p>
                            
                            <div className="absolute right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                                bg-[linear-gradient(290deg,#009064_0%,#46a37e_25.41%,#e6e47c_100%)]"></div>
                        </a>
                        <a href="https://prmrfn.mmr.ua/" className="relative flex items-center gap-6 pr-14 md:basis-[calc(50%-12px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                                shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                                <img src={Prmrfn} alt="Delo.ua" className="w-2/3"/>
                            </div>
                            <p className="text-base font-semibold text-white lg:text-lg">PR-марафон: у дзеркалі реальності</p>
                            
                            <div className="absolute right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                                bg-[linear-gradient(290deg,#009064_0%,#46a37e_25.41%,#e6e47c_100%)]"></div>
                        </a>
                        <a href="https://mrktng.mmr.ua/" className="relative flex items-center gap-6 pr-14 md:basis-[calc(50%-12px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                                shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                                <img src={Mrktng} alt="Delo.ua" className="w-2/3"/>
                            </div>
                            <p className="text-base font-semibold text-white lg:text-lg">MRKTNG MRTH: під сонцем інсайтів</p>
                            
                            <div className="absolute right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                                bg-[linear-gradient(290deg,#009064_0%,#46a37e_25.41%,#e6e47c_100%)]"></div>
                        </a>
                        <a href="https://she.womo.ua/" className="relative flex items-center gap-6 pr-14 md:basis-[calc(50%-12px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                                shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                                <img src={She} alt="Delo.ua" className="w-2/3"/>
                            </div>
                            <p className="text-base font-semibold text-white lg:text-lg">SHE CONGRESS: Рішуча. Справжня. Небайдужа.</p>
                            
                            <div className="absolute right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                                bg-[linear-gradient(290deg,#009064_0%,#46a37e_25.41%,#e6e47c_100%)]"></div>
                        </a>
                    </div>
                </ScrollAnimation>

            </div>

        </section>




    );
};

function CircleLogo({ label }) {
  return (
    <div
      className="
        w-[18%] min-w-[70px]
        aspect-square
        bg-white
        rounded-full
        shadow-xl
        flex items-center justify-center
        text-xs md:text-sm font-semibold
      "
    >
      {label}
    </div>
  );
}

export default EventOrganizers;